<script setup>
import { ref, watchEffect } from 'vue';

const props = defineProps({
  label: {
    type: String
  },
  subtitle: {
    type: String
  },
  isLoading: {
    type: Boolean
  },
  updated: {
    type: Boolean
  },
  divider: {
    type: Boolean,
    default: true
  }
});

const autoHide = ref(false);

watchEffect(() => {
  if (props.isLoading) {
    autoHide.value = true;
    setTimeout(() => {
      autoHide.value = false;
    }, 8000);
  }
});
</script>

<template>
  <div class="tw-mb-5">
    <div class="tw-pb-5">
      <div class="tw-flex tw-items-center tw-align-top">
        <label class="tw-mr-3 tw-flex tw-flex-col tw-text-[0.875rem] tw-font-bold">{{ label }}</label>

        <div v-if="isLoading">
          <v-progress-circular :width="2" size="15" color="#34c7d6" indeterminate></v-progress-circular>
        </div>
        <div v-else-if="autoHide" class="tw-flex tw-items-center tw-space-x-2 tw-text-[#34c7d6]">
          <v-icon color="#34c7d6" size="small">mdi-check-circle</v-icon>
          <span class="tw-text-[0.8rem] tw-font-medium">Saved</span>
        </div>
      </div>
      <span v-if="subtitle" class="tw-mt-1 tw-text-[0.813rem] tw-font-normal">{{ subtitle }}</span>
      <div class="tw-mt-3">
        <slot />
      </div>
    </div>
    <v-divider v-if="divider" />
  </div>
</template>

<style scoped></style>
